import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from 'Global/Layout';
import SEO from 'Global/SEO';
import Hero from 'Global/Hero/Hero';
import TextContent from 'Component/TextContent/TextContent';
import CtaSection from 'Component/CtaSection/CtaSection';

import WhoAreWe from 'TextContentData/AboutUs/WhoAreWe.json';
import { OneStopShop } from 'TextContentData/AboutUs/OneStopShop.js';
import { Story } from 'TextContentData/AboutUs/Story.js';
import { Beliefs } from 'TextContentData/AboutUs/Beliefs.js';
import BackgroundImage from 'gatsby-background-image';

const AboutUs = () => {
	const images = useStaticQuery(IMAGES_QUERY);
	return (
		<Layout>
			<SEO title="About Us" description="" />
			<Hero
				heading={
					<>
						We work to make <br /> your money work for you
					</>
				}
				customClass="bgAboutUs"
			/>
			<TextContent
				heading="Who are we?"
				data={WhoAreWe}
				customClass="whoAreWe"
			/>
			<TextContent
				heading="One-stop shop for all investments needs"
				data={OneStopShop}
				customClass="paraAlwaysLeft"
			/>
			<BackgroundImage
				fluid={images.teamWork.childImageSharp.fluid}
				style={{ height: '22rem' }}
			></BackgroundImage>
			<CtaSection heading="Want to understand how your business can benefit? Connect with us" />
			<TextContent
				heading="The story behind"
				data={Story}
				customClass="paraAlwaysLeft"
			/>
			<TextContent
				heading="Our Beliefs."
				data={Beliefs}
				customClass="paraAlwaysLeft"
			/>
			<CtaSection
				heading="Do something today, that your future self will thank you for."
				subheading="Sign up with one of the top online investment platforms -- us!"
				customClass="inFooter"
				auth
			/>
		</Layout>
	);
};

const IMAGES_QUERY = graphql`
	{
		teamWork: file(relativePath: { eq: "pages/about/team-work.png" }) {
			childImageSharp {
				fluid {
					...GatsbyImageSharpFluid_withWebp_noBase64
				}
			}
		}
	}
`;

export default AboutUs;
